import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Barbell } from "@phosphor-icons/react";

export default function CopyWorkoutDialog({
  workout,
  programs,
  targetProgramId,
  setTargetProgramId,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog
      open={!!workout}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
    >
      <DialogContent
        className="bg-[#171717] border-[#262626] text-white max-w-sm"
        data-testid="copy-workout-dialog"
      >
        <DialogHeader>
          <DialogTitle
            className="font-bold tracking-tight uppercase"
            style={{ fontFamily: "Barlow Condensed, sans-serif" }}
          >
            COPIA SCHEDA
          </DialogTitle>
        </DialogHeader>
        <div className="py-2">
          {workout && (
            <div className="flex items-center gap-3 mb-4 p-3 bg-[#0A0A0A] rounded-lg border border-[#1A1A1A]">
              <Barbell
                size={18}
                weight="fill"
                className="text-[#007AFF] flex-shrink-0"
              />
              <div>
                <p className="text-sm font-medium text-white">{workout.title}</p>
                <p className="text-xs text-zinc-500">
                  {workout.exercises?.length || 0} esercizi
                </p>
              </div>
            </div>
          )}
          <Label className="text-zinc-400 text-xs uppercase tracking-wider">
            Programma di destinazione
          </Label>
          <Select value={targetProgramId} onValueChange={setTargetProgramId}>
            <SelectTrigger
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="copy-target-program"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#171717] border-[#262626]">
              <SelectItem value="none" className="text-white">
                Senza programma
              </SelectItem>
              {programs.map((p) => (
                <SelectItem key={p.id} value={p.id} className="text-white">
                  {p.title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            className="border-[#262626] text-zinc-300 hover:bg-[#1A1A1A]"
            data-testid="copy-cancel"
          >
            Annulla
          </Button>
          <Button
            onClick={onConfirm}
            className="bg-[#007AFF] hover:bg-[#3395FF] text-white"
            data-testid="copy-confirm"
          >
            Copia
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
